var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnExchangeVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7685 11.6626C15.0772 11.9718 15.0772 12.4731 14.7685 12.7823L11.7875 15.7681C11.6392 15.9166 11.4382 16 11.2285 16C11.0189 16 10.8178 15.9166 10.6696 15.7681L7.68855 12.7823C7.37986 12.4731 7.37986 11.9718 7.68855 11.6626C7.99725 11.3534 8.49774 11.3534 8.80644 11.6626L10.4381 13.2969L10.4384 5.88851C10.4384 5.45125 10.7923 5.09679 11.2289 5.09681C11.6654 5.09682 12.0193 5.45131 12.0193 5.88857L12.019 13.2968L13.6506 11.6626C13.9593 11.3534 14.4598 11.3534 14.7685 11.6626ZM8.44478 4.33741C8.13608 4.6466 7.63559 4.6466 7.3269 4.33741L5.64983 2.65764L5.64983 10.3676C5.64983 10.8049 5.29593 11.1593 4.85937 11.1593C4.42281 11.1593 4.06891 10.8049 4.06891 10.3676L4.06891 2.74868L2.48274 4.3374C2.17404 4.6466 1.67355 4.6466 1.36486 4.3374C1.05616 4.02821 1.05616 3.52691 1.36486 3.21772L4.34588 0.231894C4.65457 -0.0772986 5.15506 -0.0772985 5.46376 0.231894L8.44478 3.21772C8.75347 3.52691 8.75347 4.02821 8.44478 4.33741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExchangeVertical);
export default __webpack_public_path__ + "static/media/icn-exchange-vertical.ee7c0f1069fa471da8613268a6d160b6.svg";
export { ForwardRef as ReactComponent };